import { render, staticRenderFns } from "./UserInfoCard.vue?vue&type=template&id=784dc989"
import script from "./UserInfoCard.vue?vue&type=script&lang=ts"
export * from "./UserInfoCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports